﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { Utils } from "@tools";

interface IAtomScope extends ng.IScope {
    _editing: boolean;
    _displayClick: (event: ng.IAngularEvent) => void;
    _editClick: (event: ng.IAngularEvent) => void;
    _editMode: boolean;
}

@NgComponent({
    token: Token.KbAtom,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbAtom extends Directive {
    
    constructor($timeout: ng.ITimeoutService) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-atom");
        this.scope = false;
        this.replace = true;
        this.transclude = {
            display: "?kbAtomDisplay",
            edit: "?kbAtomEdit"
        };

        this.link = (scope: IAtomScope, element: ng.IAugmentedJQuery, atts: ng.IAttributes) => {
            scope._editMode = scope.$eval(atts.editMode) == true;

            let guid = Utils.shortId();
            let eventName = "click.kbAtom." + guid;

            let documentClick = (e: JQueryEventObject) => {
                // ignore if it was this kbAtom that was clicked
                if (!$(e.target).is(element) && !$.contains(element[0], e.target as Element)) {
                    scope.$apply(() => {
                        scope._editing = false;
                    });
                    $(document).off(eventName, documentClick);
                }
            };

            let changeEditMode = (val: boolean) => {
                scope._editing = val;
                if (val) {
                    scope._displayClick = ($event: ng.IAngularEvent) => {
                    };
                    // scope._editClick = ($event: ng.IAngularEvent) => {
                    // }
                } else {
                    scope._displayClick = ($event: ng.IAngularEvent) => {
                        if ($(element).hasClass("disabled") || $(element).attr("disabled")) return;
                        // $event.stopPropagation();

                        scope._editing = true;

                        $(document).on(eventName, documentClick);
                    };

                    // scope._editClick = ($event: ng.IAngularEvent) => {
                    //    $event.stopPropagation();
                    // }
                }
            };
                
            let editAtt = atts.editMode;
            if (editAtt) {
                scope.$watch(() => scope.$eval(editAtt), changeEditMode);
            } else {
                changeEditMode(false);
            }

            scope.$on("$destroy", () => {
                $(document).off(eventName, documentClick);
            });
               
        };
    }
}
